import { render, staticRenderFns } from "./MaterialPageWrapper.vue?vue&type=template&id=116d0931&lang=html"
import script from "./MaterialPageWrapper.vue?vue&type=script&lang=js"
export * from "./MaterialPageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/rajalex/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports